var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.fetchPrimaryArticle(_vm.slug).reason && _vm.fetchPrimaryArticle(_vm.slug).reason.note)?_c('div',{staticClass:"intro-reason"},[_c('span',[_vm._v(_vm._s(_vm.fetchPrimaryArticle(_vm.slug).reason.note))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }